<div class="slideshow">
	<div class="app-modal__overlay"></div>
	<div class="slideshow__close" (click)="closeModal()">
		<app-svg svg="icons.svg#general--close" [alt]="'Close icon'" aria-hidden="true"></app-svg>
	</div>
	<div class="slideshow__presenting">
		<div class="slideshow__presenting-previous" (click)="selectPrevious()">
			<app-svg svg="icons.svg#general--arrow--left" [alt]="'Arrow left icon'" aria-hidden="true"></app-svg>
		</div>
		<div class="slideshow__presenting-image">
			<img src="{{ selected.val }}" alt="{{selected.label}}" />
		</div>
		<div class="slideshow__presenting-next" (click)="selectNext()">
			<app-svg svg="icons.svg#general--arrow--right" [alt]="'Arrow right icon'" aria-hidden="true"></app-svg>
		</div>
	</div>
	<div #image_scroll class="slideshow__gallery">
		<ul class="slideshow__gallery-img-list">
			<li *ngFor="let image of srcs; let index = index" (click)="selectImage(image.src, index,image.label)"
				[class.selected]="index === selected.pos" [ngStyle]="{ 'background-image': 'url(\'' + image.src + '\')' }"
				title="{{image.label}}">
			</li>
		</ul>
	</div>
</div>
